import React, { useState } from 'react';
import { FiDownload, FiX, FiShare } from 'react-icons/fi';
import { usePwaInstall } from '../../hooks/usePwaInstall';

export default function InstallAppPrompt() {
  const {
    canNativeInstall,
    showIosHint,
    showInstallBanner,
    install,
    dismiss,
  } = usePwaInstall();
  const [installing, setInstalling] = useState(false);

  if (!showInstallBanner) return null;

  const handleInstall = async () => {
    if (!canNativeInstall) return;
    setInstalling(true);
    try {
      await install();
    } finally {
      setInstalling(false);
    }
  };

  const subtitle = showIosHint
    ? 'Tap Share, then select Add to Home Screen to install UCASAAPP on your device.'
    : 'Install on your home screen for quick access and a full-screen app experience.';

  return (
    <div className="pwa-install-banner" role="region" aria-label="Install UCASAAPP">
      <img
        src={`${process.env.PUBLIC_URL || ''}/logo-ucasaapp.png`}
        alt=""
        className="pwa-install-logo"
        aria-hidden
      />
      <div className="pwa-install-copy">
        <p className="pwa-install-title">Install UCASAAPP</p>
        <p className="pwa-install-subtitle">{subtitle}</p>
      </div>
      <div className="pwa-install-actions">
        {canNativeInstall ? (
          <button
            type="button"
            className="pwa-install-btn"
            onClick={handleInstall}
            disabled={installing}
            aria-busy={installing}
          >
            <FiDownload aria-hidden />
            {installing ? 'Installing…' : 'Install App'}
          </button>
        ) : showIosHint ? (
          <span className="pwa-install-ios-hint" title="Use Share → Add to Home Screen">
            <FiShare aria-hidden />
            <span className="pwa-install-ios-label">Share</span>
          </span>
        ) : null}
        <button
          type="button"
          className="pwa-install-dismiss"
          onClick={dismiss}
          aria-label="Dismiss install prompt"
        >
          <FiX />
        </button>
      </div>
    </div>
  );
}
